var registerButton  = $('.js-cart-register-btn');
var oneTimeButton   = $('.js-without-register-btn');
var logInButton     = $('.js-cart-login');
var logInCartButton     = $('.js-cart-login-btn');


// $('.js-first-time:not(.not-valid)').addClass('d-none');

$('.js-cart-login').hide();

$('.js-email-validate').attr('disabled', 'disabled');

$('#js-save-order-email').on('input change', function () {
    var email = $(this).val();
    if (validateEmail(email)) {
        $.ajax({
            type: "POST",
            url: '/ulozit-email-zakaznika',
            data: {
                email: email,
            },
        });
    }
});

$('.js-email').on('input change', function () {
    if (validateEmail($(this).val())) {
        $('.js-span-validation').removeClass('fail');
        $('.js-span-validation').addClass('success');
        $('.js-email-validate').removeAttr('disabled');
    } else {
        $('.js-span-validation').removeClass('success');
        $('.js-span-validation').addClass('fail');
        $('.js-email-validate').attr('disabled', 'disabled');
    }
});

if ($('.js-first-time').hasClass('not-valid')) {
    hideAds();
    $('.js-second-step').removeClass('d-none');
    $('.js-first-time').removeClass('d-none');
    $('.js-cart-first').addClass('d-none');
    $('.js-cart-submit').removeClass('d-none');

}

if ($('.js-first-time').hasClass('js-user-logged')) {
    hideAds();
    $('.js-first-time').removeClass('d-none');
    $('.js-second-step').removeClass('d-none');
    $('.js-cart-submit').removeClass('d-none');
    $('.js-cart-login').hide();
}


function hideAds() {
    $('.js-support').removeClass('d-sm-block').hide();
    $('.js-benefits').removeClass('d-sm-block').hide();
}

oneTimeButton.click(function () {
    hideAds();

    $(this).addClass('active');
    registerButton.removeClass('active');
    logInCartButton.removeClass('active');

    $('.js-second-step').removeClass('d-none');
    $('.js-first-time').removeClass('d-none');
    $('.js-cart-password').addClass('d-none');
    $('.js-user-register').attr("checked", false);
    $('.js-cart-login').hide();

    $('html,body').animate({
        scrollTop: $('.js-without-register-anchor').offset().top - 100
    }, 500);
    $('#frm-form-name').focus();
});

registerButton.click(function () {
    hideAds();

    $(this).addClass('active');
    oneTimeButton.removeClass('active');
    logInCartButton.removeClass('active');

    $('.js-second-step').removeClass('d-none');
    $('.js-first-time').removeClass('d-none');
    $('.js-cart-password').removeClass('d-none');
    $('.js-user-register').attr("checked", true);
    $('.js-cart-login').hide();

    $('html,body').animate({
        scrollTop: $('.js-without-register-anchor').offset().top - 100
    }, 500);
    $('#frm-form-name').focus();
});

logInCartButton.click(function () {
    hideAds();

    $(this).addClass('active');
    oneTimeButton.removeClass('active');
    registerButton.removeClass('active');

    $('.js-first-time').addClass('d-none');
    $('.js-cart-login').show();

    $('html,body').animate({
        scrollTop: $('.js-cart-login').offset().top - 100
    }, 500);
});


$('.js-email-validate').click(function (e) {
    var email = $('.js-email').val(),
        link = $(e.target).data('link');

    $.ajax({
        url: link,
        data: {
          email: email
        }
    }).done(function (data) {

        $('.js-email-validated').val(email);

        if (data.email_validation && data.user_exists) {
            hideAds();
            $('.js-cart-first').addClass('d-none');
            $('.js-second-step').removeClass('d-none');
            $('.js-cart-submit').removeClass('d-none');
            $('.js-cart-login').show();
        }

        if (data.email_validation && !data.user_exists) {
            $('.js-cart-first').addClass('d-none');
            $('.js-second-step').removeClass('d-none');
            $('.js-cart-submit').removeClass('d-none');
        }

        $('.js-email-validated').trigger('change');
    });
});

function validateEmail(email) {
    return /\S+@\S+\.\S+/.test(email)
}

/**
 * Udalost, ktera nastane pri stisknuti klavesy na inputu
 * @param {type} $e
 * @returns {undefined}
 */
var $cartIcEvent = function(e){
    e.preventDefault();
    var $this = $('.js-ic');
    var $button = $(this);
    var $ic = $this.val();
    var $len  = $ic.length;

    if($len < 8) {
        return;
    }

    var $thisClass = $this.attr("class");
    var $url = $button.attr('href');
    var $data = { ic: $ic };

    /**
     * Metoda se vola po uspesnem provedeni ajaxu
     * @param json $json
     * @returns {undefined}
     */
    var $success = function( $json ) {

        if( $json.status === 'ok') {
            var $data = $json.data;

            // predvyplneni policek formulare
            $.each($data, function($key, $value) {
                $("*[name='" + $key + "']").val($value);
            });

            // zmena barvy ramecku - ok
            $this.css("border-color", "green");

            return;
        }

        //alert($json.message);

        console.log("IC error: " + $json.message);

        // zmena barvy ramecku - error
        $this.css("border-color", "red");

    };

    /**
     * Metoda se vola po dokonceni ajaxu
     * @returns {undefined}
     */
    var $done = function( ){ };

    // zmena barvy ramecku - processing
    $this.css("border-color", "orange");

    // odeslani nette ajaxu
    $.nette.ajax({
        url:    $url,
        data:   $data,
        success: $success
    }).done( $done );

};

// odchyceni udalosti
$('.js-ic-info').click($cartIcEvent);

